import styled from 'styled-components';

export const Nav = styled.nav`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
`;

export const List = styled.ol`
  display: flex;
  align-items: center;
  width: max-content;
  min-width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  white-space: nowrap;
`;

export const Item = styled.li`
  display: inline-flex;
  align-items: center;
  min-width: 0;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.4;
`;

export const Separator = styled.span`
  margin: 0 8px;
  color: #adb5bd;
  font-size: 18px;
  line-height: 1;
`;

export const CrumbLink = styled.a`
  color: #6c757d;
  text-decoration: none;

  &:hover,
  &:focus {
    color: #be1622;
    text-decoration: underline;
  }
`;

export const Current = styled.span`
  color: #212529;
  font-weight: 500;
`;
